import { useCallback, useMemo, useState } from 'react';

import { Row, Col } from 'twyne-new.ui';

import { usePivotData } from '../Context';

import PivotData from "./parse";
import "./index.scss";

export default function PivotTable({ data }) {
  const { cols, rows, metric, showHeatmap, heatmapColor } = usePivotData()
  const [hoverCell, setHoverCell] = useState(null)
  const onHoverCell = useCallback(cell => {
    setHoverCell(cell)
  }, [])
  const onTableMouseLeave = useCallback(() => {
    setHoverCell(null)
  }, [])

  const parsed = useMemo(() => {
    if (!data || data.children?.length === 0) return null
    return new PivotData({
      cols, rows, metric, data, showHeatmap, heatmapColor, hoverCell, onHoverCell,
    }).handle()
  }, [cols, rows, metric, data, showHeatmap, heatmapColor, hoverCell, onHoverCell])

  if (!data || data.children?.length === 0) {
    return <span className='font-semibold'>No results to show.</span>;
  }

  if (!parsed || (!parsed.Table && !parsed.Body)) {
    return null
  }

  const { scroll, sticky, Cols, Rows, Body, Table } = parsed

  if (sticky === 'th-cols') {
    return <div onMouseLeave={onTableMouseLeave}><ColSticky Table={Table} /></div>
  }

  if (sticky === 'th-rows') {
    return <div onMouseLeave={onTableMouseLeave}><RowSticky Cols={Cols} Rows={Rows} Body={Body} /></div>
  }

  return <div onMouseLeave={onTableMouseLeave}><ScrollableTable Table={Table} scroll={scroll} /></div>
}

function ColSticky({ Table }) {
  return <div className="my-3 content">
    <Row noGutters>
      <Col className="overflow-y-auto">
        <table className="m-0 w-full table-fixed border-collapse">
          {Table.map((t, j) => {
            if (j === 0) return <thead key={j} className='sticky'>{t.map((cells, i) => <tr key={i}>{cells.map(cell => cell)}</tr>)}</thead>
            return <tbody key={j}>{t.map((cells, i) => <tr key={i}>{cells.map(cell => cell)}</tr>)}</tbody>
          })}
        </table>
      </Col>
    </Row>
  </div>
}

function RowSticky({ Cols, Rows, Body }) {
  return <div className="my-3 content">
    <Row noGutters>
      <Col className="pivot align-self-end" style={{ paddingBottom: '4px' }}>
        <table className="m-0 w-full table-fixed border-collapse">
          {Rows.map((cells, i) => <tr key={i}>{cells.map(cell => cell)}</tr>)}
        </table>
      </Col>
      <Col className="pivot scroll-x">
        <table className="m-0 w-full table-fixed border-collapse">
          {[...Cols, ...Body].map((cells, i) => <tr key={i}>{cells.map(cell => cell)}</tr>)}
        </table>
      </Col>
    </Row>
  </div>
}

function ScrollableTable({ Table, scroll }) {
  return <div className={`content pivot ${scroll ? 'scroll' : ''}`}>
    <table className="m-0 w-full table-fixed border-collapse">
      {Table.map((t, j) => {
        if (j === 0) return <thead key={j}>{t.map((cells, i) => <tr key={i}>{cells.map(cell => cell)}</tr>)}</thead>
        return <tbody key={j}>{t.map((cells, i) => <tr key={i}>{cells.map(cell => cell)}</tr>)}</tbody>
      })}
    </table>
  </div>
}
